import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { ReleaseDto } from '../dtos/release.dto';
import { ReleaseRequestModel } from '../models/release-request.model';
import { ReleaseModel } from '../models/release.model';
import {
  mapReleaseDtoToReleaseModel,
  mapReleaseRequestModelToReleaseRequestDto,
} from '../utils/releases-mapping.utils';

export const createAppRelease: AsyncThunk<
  ReleaseModel,
  ReleaseRequestModel,
  Record<number, unknown>
> = createAsyncThunk(
  'app/releases/create-app-release',
  async (data: ReleaseRequestModel, { rejectWithValue }) => {
    try {
      const dataDto = mapReleaseRequestModelToReleaseRequestDto(data);
      const basePath = `/apps/${data.id}/releases`;
      const resp: AxiosResponse<ReleaseDto> = await axiosInstance.post(
        basePath,
        dataDto,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      return mapReleaseDtoToReleaseModel(resp.data);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
